import OfficeTaskpane from './OfficeTaskpane';

export default OfficeTaskpane;
